<h2>{{ 'research.portal.featured.researchers' | translate }}</h2>
<mulo-horizontaller
  [loading]="false"
  [buttonWidth]="media.is('lt-md') ? 32 : 150"
  [showPageBullets]="researchers()?.length > researchersToDisplay"
  [rtl]="i18nService.isLangRtl()"
  >
  @for (researcher of researchers(); track researcher) {
    <mulo-horizontaller-item [maxWidth]="null">
      <mulo-avatar
        [size]="150"
        [image]="researcher.imageURL"
        shape="square"
        [radius]="6"
        class="avatar"
        [description]="'research.alt.profile.img.with.name' | translate : { value: researcher.displayName }"
      ></mulo-avatar>
      <h3 class="name">
        <a
          [routerLink]="['/profile/' + researcher.urlIdentifier]"
          [queryParams]="{ institution: institution }"
                attr.aria-label="{{
                    'research.aria.search.go.to.profile' | translate : { value: researcher.displayName }
                }}"
          >
          {{ researcher.displayName }}
        </a>
      </h3>
      <p class="title">
        @if (researcher.displayTitle) {
          {{ researcher.displayTitle }}
        } @else {
          @if (researcher?.currentAffiliation?.length > 0) {
            {{
            researcher.currentAffiliation[0]
            | researcherTitle : { generalPosition: researcher.generalPosition, suffix: ',' }
            }}
            {{ researcher.currentAffiliation[0].organizationCode | translate }}
          }
        }
      </p>
      @if ('research.portal.featured.researcher.' + researcher.userID + '.text' | translate) {
        <p
          class="quote"
          innerHTML="{{ 'research.portal.featured.researcher.' + researcher.userID + '.text' | translate }}"
        ></p>
      }
    </mulo-horizontaller-item>
  }
</mulo-horizontaller>
<img src="assets/images/white-spots.svg" class="white-spots" alt="" />
